import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmPaidServicesDisabledError } from '@/core/error/transport/tmPaidServicesDisabledError'

export const paidServicesDisabledErrorRule: CustomErrorRule = {
  subCodes: ['user.paid_services_disabled'],
  klass: TmPaidServicesDisabledError,
}
